function endsWith(str, suffix) {
    return str.indexOf(suffix, str.length - suffix.length) !== -1;
}

jQuery.fn.highlight = function(pat) {
    function innerHighlight(node, pat) {
        var skip = 0;
        if (node.nodeType == 3) {
            var pos = node.data.toUpperCase().indexOf(pat);
            if (pos >= 0) {
                var spannode = document.createElement('a');
                spannode.href = '#';
                spannode.onclick = "return false;";
                spannode.className = 'find-within-mark';

                var middlebit = node.splitText(pos);
                var endbit = middlebit.splitText(pat.length);
                var middleclone = middlebit.cloneNode(true);
                spannode.appendChild(middleclone);
                middlebit.parentNode.replaceChild(spannode, middlebit);
                skip = 1;
            }
            else {
                if(pat[pat.length-1] == ' ') {
                    var tmpPos = node.data.toUpperCase().indexOf(pat.trim());
                    // if(pat.trim() !== node.data.toUpperCase() || endsWith(node.data.toUpperCase(), pat)) {
                    //     tmpPos = -1;
                    // }
                    if(tmpPos >= 0 && endsWith(node.data.toUpperCase(), pat.trim())) {
                        if($(node).context.parentElement.tagName == 'SPAN' && $(node).context.parentElement.nextSibling.data[0] == ' ') {
                            node.data = node.data + ' ';
                            var spannode = document.createElement('a');
                            spannode.href = '#';
                            spannode.onclick = "return false;";
                            spannode.className = 'find-within-mark';

                            var middlebit = node.splitText(tmpPos);
                            var endbit = middlebit.splitText(pat.length);
                            var middleclone = middlebit.cloneNode(true);
                            spannode.appendChild(middleclone);
                            middlebit.parentNode.replaceChild(spannode, middlebit);
                            skip = 1;
                            $(node).context.parentElement.nextSibling.data = $(node).context.parentElement.nextSibling.data.substring(1);
                        }
                    }
                    // console.log($(node).next());
                }
            }
        }
        else if (node.nodeType == 1 && node.childNodes && !/(script|style)/i.test(node.tagName)) {
            for (var i = 0; i < node.childNodes.length; ++i) {
                i += innerHighlight(node.childNodes[i], pat);
            }
        }
        return skip;
    }
    return this.each(function() {
        innerHighlight(this, pat.toUpperCase());
    });
};

jQuery.fn.removeHighlight = function() {
    function newNormalize(node) {
        // console.log(node.childNodes);
        for (var i = 0, children = node.childNodes, nodeCount = children
            .length; i < nodeCount; i++) {
            var child = children[i];
            if (child.nodeType == 1) {
                newNormalize(child);
                continue; }
            if (child.nodeType != 3) { continue; }
            var next = child.nextSibling;
            if (next == null || next.nodeType != 3) { continue; }
            var combined_text = child.nodeValue + next.nodeValue;
            if(combined_text[combined_text.length-1] == ' ' && $(node).context.tagName == 'SPAN') {
                combined_text = combined_text.substring(0,combined_text.length-1);
                if ($(node).context.nextSibling) {
                    $(node).context.nextSibling.data = ' ' + $(node).context.nextSibling.data;
                }
            }
            new_node = node.ownerDocument.createTextNode(combined_text);
            node.insertBefore(new_node, child);
            node.removeChild(child);
            node.removeChild(next);
            i--;
            nodeCount--;

        } }
    return this.find(".find-within-mark").each(function() {
        var thisParent = this.parentNode;
        if(this.firstChild && this.firstChild!== null) {
            thisParent.replaceChild(this.firstChild, this);
        }
        newNormalize(thisParent);
    }).end();
};

jQuery.fn.hasOverflown = function () {
    var res = {highlightClass: false};

    var cont = $('<div></div>').css("display", "table")
        .css("z-index", "-1").css("position", "absolute")
        .css("font-family", this.css("font-family"))
        .css("font-size", this.css("font-size"))
        .css("font-weight", this.css("font-weight")).appendTo('body');

    cont.text(this.text());

    res.didOverflow = (cont.outerWidth() > this.outerWidth());
    var marks = this.find('.find-within-mark');
    var mainEl = this;
    $.each(marks, function(i, mark) {
        var pos = $(mark).position();
        if(pos.left > (mainEl.outerWidth()-25)) {
            res.highlightClass = true;
            return false;
        }
    });
    cont.remove();
    return res;
}